<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：营业数据
      -->
  <div class="user">

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%"
         v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column type="id" prop="id" label="ID" ></el-table-column>
          <el-table-column type="id" prop="id" label="订单数量"  ></el-table-column>
          <el-table-column type="id" prop="id" label="下单金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="取消订单数量" ></el-table-column>
          <el-table-column type="id" prop="id" label="取消订单金额"  ></el-table-column>
          <el-table-column type="id" prop="id" label="退单数量" ></el-table-column>
          <el-table-column type="id" prop="id" label="退货金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="销售金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="优惠金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="商品销售金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="实际金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="损耗金额" ></el-table-column>
          <el-table-column type="id" prop="id" label="毛利" ></el-table-column>
          <el-table-column type="id" prop="id" label="毛利率" ></el-table-column>
       

       
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="curPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
      </div>
    </div>

 
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [{
        id:0,

      },{
        id:0,

      }],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {

      },
     
    };
  },
  created() {

  },

  methods: {
     /*搜索查询*/
     onSubmit() {
      let self = this
      self.curPage = 1

    },
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },
     /*选择第几页*/
     handleCurrentChange(val) {
      this.curPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },
    getTableList(){

    }

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/report/bdata/Compony.vue